module.exports = __webpack_public_path__ + "media/toolkits/COVID19-video-b765d04a.png";